import clsx from 'clsx'

import Link from '@/atoms/Link/Link'
import { ReactComponent as InstagramIcon } from 'public/assets/influencer/icons/social/Instagram.svg'
import { ReactComponent as TwitterIcon } from 'public/assets/influencer/icons/social/Twitter.svg'
import { ReactComponent as LinkedInIcon } from 'public/assets/influencer/icons/social/Linkedin.svg'
import { ReactComponent as FacebookIcon } from 'public/assets/influencer/icons/social/Facebook.svg'

const extraFooterLinks: FooterLink[] = [
  { page_title: 'Terms of Service', slug: '/terms/' },
  { page_title: 'Privacy Policy', slug: '/privacy/' },
  { page_title: 'Sitemap', slug: '/sitemap.xml' }
]

const socialLinks = [
  {
    title: 'instagram',
    href: 'https://www.instagram.com/pepper__inc/',
    Icon: InstagramIcon
  },
  {
    title: 'linkedin',
    href: 'https://www.linkedin.com/company/pepperinc',
    Icon: LinkedInIcon
  },
  {
    title: 'twitter',
    href: 'https://twitter.com/Pepper_Content',
    Icon: TwitterIcon
  },
  {
    title: 'facebook',
    href: 'https://www.facebook.com/Pepper-Co-322356101506651/',
    Icon: FacebookIcon
  }
]

const FooterRights = (): JSX.Element => {
  const textColorClass = 'text-[#B1ADD8]'
  return (
    <section className="container lg:flex lg:items-start lg:justify-between | px-5 pt-8 pb-12 sm:px-10 lg:px-6 mx-auto">
      <div className="lg:flex lg:space-x-8 | lg:pt-1">
        <p className={clsx('text-small inline-block | mb-2 ', textColorClass)}>
          © {new Date().getFullYear()}, Pepper Content Inc. All Rights
          Reserved.
        </p>
        <ul className="lg:flex lg:space-x-8">
          {extraFooterLinks.map(link => (
            <li key={link.slug} className="text-small  mb-2  list-none">
              <Link
                className={clsx(
                  'inline-block hover:text-blue-50 focus:text-blue-50 focus:outline-none',
                  textColorClass
                )}
                href={link.slug}
              >
                {link.page_title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-6 lg:mt-0">
        <h3 className="text-yellow-70 text-small font-medium uppercase tracking-widest | mb-4">
          Social
        </h3>
        <div className="flex space-x-6">
          {socialLinks.map(({ title, href, Icon }) => (
            <Link
              key={title}
              href={href}
              target="_blank"
              title={title}
              rel="noopener noreferrer"
            >
              <Icon className="h-6 w-6 | text-blue-web-90" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FooterRights
